import FoodIcon from '@material-ui/icons/ViewList';

import KiotProductList from './KiotProductList';

export default {
  list: KiotProductList,
  icon: FoodIcon,
};
